import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currencySelect", "label"]

  connect() {
    this.updateLabels()
  }

  updateLabels() {
    const currency = this.currencySelectTarget.value
    if (!currency) return

    this.labelTargets.forEach(label => {
      const baseText = label.dataset.baseText || label.textContent.replace(/\s*\([^)]*\)/g, "").trim()
      label.textContent = `${baseText} (${currency})`
    })
  }
}
